import { useTranslation } from 'react-i18next';
import { enUS, jaJP, type Locale } from '@app/ui';

const localeMap: Record<string, Locale> = {
    'en-US': enUS,
    'ja-JP': jaJP,
};

/**
 * Hook to get the current Ant Design locale based on i18n language
 */
export const useAntdLocale = (): Locale => {
    const { i18n } = useTranslation();
    const currentLanguage = i18n.language || 'en-US';
    return localeMap[currentLanguage] || localeMap['en-US'];
};
